/* Lynexas — upsell "Would you like to add a stand?".
   Tick checkbox -> hien stepper so luong. Bam "Add to cart":
   them stand vao gio TRUOC, roi de form native cua Horizon them san pham chinh
   (no se tu mo cart drawer + cap nhat icon gio => chi mo drawer MOT lan,
   luc do trong gio da co ca hai). Khong dung lai flow native cua san pham chinh. */
(() => {
  if (window.__lyxStandUpsell) return;
  window.__lyxStandUpsell = true;

  const qty = (box) => {
    const el = box.querySelector('[data-lyx-upsell-count]');
    return Math.max(1, parseInt(el?.textContent || '1', 10) || 1);
  };

  const setQty = (box, n) => {
    const el = box.querySelector('[data-lyx-upsell-count]');
    const minus = box.querySelector('[data-lyx-upsell-minus]');
    if (el) el.textContent = n;
    if (minus) minus.disabled = n <= 1;
  };

  async function addStand(box) {
    const variantId = box.dataset.lyxStandId;
    if (!variantId) return;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty(box) }] }),
      });
    } catch (e) {
      /* them stand that bai: van de san pham chinh duoc them binh thuong */
    }
  }

  document.addEventListener('click', (event) => {
    const box = document.querySelector('[data-lyx-upsell]');

    // stepper
    const plus = event.target.closest('[data-lyx-upsell-plus]');
    const minus = event.target.closest('[data-lyx-upsell-minus]');
    if ((plus || minus) && box) {
      event.preventDefault();
      setQty(box, plus ? qty(box) + 1 : Math.max(1, qty(box) - 1));
      return;
    }

    // modal chi tiet
    if (event.target.closest('[data-lyx-upsell-open]')) {
      event.preventDefault();
      document.querySelector('[data-lyx-upsell-modal]')?.showModal();
      return;
    }
    if (event.target.closest('[data-lyx-upsell-close]')) {
      event.preventDefault();
      document.querySelector('[data-lyx-upsell-modal]')?.close();
      return;
    }

    // Add to cart: neu da tick thi them stand truoc, roi cho form native chay tiep
    const addBtn = event.target.closest('.add-to-cart-button, [ref="addToCartButton"]');
    if (!addBtn || !box) return;

    const check = box.querySelector('[data-lyx-upsell-check]');
    if (!check?.checked) return;
    if (addBtn.dataset.lyxPassthrough === '1') {
      delete addBtn.dataset.lyxPassthrough;
      return; // lan click do chinh JS nay phat ra -> de native xu ly
    }

    event.preventDefault();
    event.stopPropagation();

    addStand(box).then(() => {
      check.checked = false;
      const qtyBox = box.querySelector('[data-lyx-upsell-qty]');
      if (qtyBox) qtyBox.hidden = true;
      setQty(box, 1);
      addBtn.dataset.lyxPassthrough = '1';
      addBtn.click();
    });
  }, true);

  // Hien/an stepper theo checkbox
  document.addEventListener('change', (event) => {
    const check = event.target.closest('[data-lyx-upsell-check]');
    if (!check) return;
    const box = check.closest('[data-lyx-upsell]');
    const qtyBox = box?.querySelector('[data-lyx-upsell-qty]');
    if (qtyBox) qtyBox.hidden = !check.checked;
    if (check.checked && box) setQty(box, 1);
  });

  // Bam ra ngoai de dong modal
  document.addEventListener('click', (event) => {
    const modal = document.querySelector('[data-lyx-upsell-modal]');
    if (modal?.open && event.target === modal) modal.close();
  });
})();
